export default {
  label: {
    title: 'Acesso ao dashboard',
    button: {
      cancelButton: 'Cancelar',
      confirmButton: 'Acessar',
    },
    form: {
      title: 'E-mail *',
      agreeTerms: {
        messageFirstPart: 'Li e aceito os ',
        messageSecondPart: 'e a',
        useTerms: 'Termos de Uso',
        privacyPolicy: 'Política de Privacidade',
      },
      error: {
        addEmail: 'O e-mail é obrigatório.',
      },
    },
  },
};
